<template>
  <div>
    <div class="mui-popover" :class="show?'mui-active show':''">
      <div class="mui-popover-arrow"></div>
      <div class="mui-scroll-wrapper">
        <div class="mui-scroll">
          <mt-cell title="快速核销">
            <mt-switch v-model="is_fast"></mt-switch>
          </mt-cell>
          <mt-cell title="使用快速核销后点 击按钮自动核销完成">
          </mt-cell>
          <mt-cell title="打印（份）">
            <mui-numbox v-model="count" :min="1" :max="5"></mui-numbox>
          </mt-cell>
        </div>
      </div>
    </div>
    <div v-if="show" class="mui-backdrop mui-active" @click="hideMenu"></div>
  </div>
</template>
<script>
  import MuiNumbox from "@/components/Mui/Numbox";
  export default {
    components: {
      MuiNumbox
    },
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      hideMenu() {
        this.$emit("show-menu", null);
      },
      handleChange(val) {
        // console.log(val);
      }
    },
    computed: {
      is_fast: {
        get() {
          return this.$store.state.settings.is_fast;
        },
        set(val) {
          this.$store.commit("SET_IS_FAST", val);
        }
      },
      count: {
        get() {
          return this.$store.state.settings.count;
        },
        set(val) {
          this.$store.commit("SET_COUNT", val);
        }
      }

    }
  };
</script>
<style scoped>
  .show {
    display: block;
    top: 57px;
    left: 90px;
  }

  .mui-popover {
    font-size: 16px;
  }
  .mui-popover-arrow {
    left: 248px;
  }

  .mui-popover {
    height: 180px;
  }
  .mint-cell {
    background-color: #f7f7f7;
  }
</style>



// WEBPACK FOOTER //
// src/components/MenuRight.vue